import React from 'react';

export default(key, lang) => {
  let mapping = {
    title: {
      en_US: 'Securing Your Admin Account with an Authenticator App',
      de_DE: 'Sichern Ihres Administratorkontos mit einer Authenticator-App',
      el_GR: 'Διασφάλιση του λογαριασμού διαχειριστή σας με μια εφαρμογή επαληθευτή',
      es_ES: 'Asegurar su Cuenta de Administrador con una Aplicación de Autenticación',
      fr_FR: 'Sécuriser votre compte administrateur avec une application Authenticator',
      fr_CA: 'Sécuriser votre compte administrateur avec une application Authenticator',
      it_IT: "Protezione dell'account amministratore con un'app di autenticazione",
      pl_PL: 'Zabezpieczanie konta administratora za pomocą aplikacji Authenticator',
      th_TH: 'การรักษาความปลอดภัยบัญชีผู้ดูแลของคุณด้วยแอพ Authenticator',
      zh_CN: '使用Authenticator App保护您的管理员帐户',
      pt_BR: 'Protegendo sua conta de administrador com um aplicativo autenticador',
      ja_JP: 'オーセンティケーターアプリで管理者アカウントを保護する',
    },
    submitText: {
      en_US: 'Verify Code',
      de_DE: 'Code überprüfen',
      el_GR: 'Επαλήθευση κωδικού',
      es_ES: 'Verifique el Código',
      fr_FR: 'Vérifier le code',
      fr_CA: 'Vérifier le code',
      it_IT: 'Verificare il codice',
      pl_PL: 'Zweryfikuj kod',
      th_TH: 'ตรวจสอบรหัส',
      zh_CN: '验证码',
      pt_BR: 'Código de verificação',
      ja_JP: 'コードを確認する',
    },
    cancelText: {
      en_US: 'Back',
      de_DE: 'Zurück',
      el_GR: 'πίσω',
      es_ES: 'Regresa',
      fr_FR: 'Retourner',
      fr_CA: 'Retourner',
      it_IT: 'Torna Indietro',
      pl_PL: 'Wróć',
      th_TH: 'กลับไป',
      zh_CN: '回去',
      pt_BR: 'Volte',
      ja_JP: '戻る',
    },
    step1Text1: {
      en_US: <h4>Download Authenticator App</h4>,
      de_DE: <h4>Authenticator App herunterladen</h4>,
      el_GR: <h4>Λήψη εφαρμογής ελέγχου ταυτότητας</h4>,
      es_ES: <h4>Descargar aplicación Authenticator</h4>,
      fr_FR: <h4>Télécharger Authenticator App</h4>,
      fr_CA: <h4>Télécharger Authenticator App</h4>,
      it_IT: <h4>Scarica l'app Authenticator</h4>,
      pl_PL: <h4>Pobierz aplikację Authenticator</h4>,
      th_TH: <h4>ดาวน์โหลดแอปตัวรับรองความถูกต้อง</h4>,
      zh_CN: <h4>下載認證器應用程式</h4>,
      pt_BR: <h4>Baixar o aplicativo autenticador</h4>,
      ja_JP: <h4>オーセンティケータアプリをダウンロード</h4>,
    },
    step1Text2: {
      en_US: (<>
        <p>
          For this step, it's best to set it up on the device you plan on using.
        </p>
        <p>
          Visit the App Store on your phone, tablet, or computer. Search for and download an authenticator app.
          You can use Google Authenticator, Microsoft Authenticator, Authy, or any TOTP-compatible app.
        </p>
      </>),
      de_DE: (<>
        <p>
        Für diesen Schritt ist es am besten, es auf dem Gerät einzurichten, das Sie verwenden möchten.
        </p>
        <p>
        Besuchen Sie den App Store auf Ihrem Smartphone, Tablet oder Computer. Suchen und laden Sie eine Authentifikator-App herunter. Sie können Google Authenticator, Microsoft Authenticator, Authy oder jede TOTP-kompatible App verwenden.
        </p>
      </>),
      el_GR: (<>
        <p>
        Για αυτό το βήμα, είναι προοιωνίτερο να το ρυθμίσετε στη συσκευή που σκοπεύετε να χρησιμοποιήσετε.
        </p>
        <p>
        Επισκεφθείτε το App Store στο τηλέφωνο, το tablet ή τον υπολογιστή σας. Αναζητήστε και κάντε λήψη μιας εφαρμογής ελέγχου ταυτότητας. Μπορείτε να χρησιμοποιήσετε το Google Authenticator, το Microsoft Authorator, το Authy ή οποιαδήποτε εφαρμογή συμβατή με TOTP.
        </p>
      </>),
      es_ES: (<>
        <p>
        Para este paso, es mejor configurarlo en el dispositivo que planeas usar.
        </p>
        <p>
        Visite a App Store em seu telefone, tablet ou computador. Pesquise e baixe um aplicativo autenticador. Você pode usar o Google Authenticator, Microsoft Authenticator, Authy ou qualquer aplicativo compatível com TOTP.
        </p>
      </>),
      fr_FR: (<>
        <p>
        Pour cette étape, il est préférable de le configurer sur l’appareil que vous prévoyez d’utiliser.
        </p>
        <p>
        Visitez l’App Store sur votre téléphone, votre tablette ou votre ordinateur. Recherchez et téléchargez une application authenticator. Vous pouvez utiliser Google Authenticator, Microsoft Authenticator, Authy ou n’importe quelle application compatible TOTP.
        </p>
      </>),
      fr_CA: (<>
        <p>
        Pour cette étape, il est préférable de le configurer sur l’appareil que vous prévoyez d’utiliser.
        </p>
        <p>
        Visitez l’App Store sur votre téléphone, votre tablette ou votre ordinateur. Recherchez et téléchargez une application authenticator. Vous pouvez utiliser Google Authenticator, Microsoft Authenticator, Authy ou n’importe quelle application compatible TOTP.
        </p>
      </>),
      it_IT: (<>
        <p>
        Per questo passaggio, è consigliabile configurarlo nel dispositivo che si intende utilizzare.
        </p>
        <p>
        Visita l'App Store sul tuo telefono, tablet o computer. Cerca e scarica un'app di autenticazione. Puoi utilizzare Google Authenticator, Microsoft Authenticator, Authy o qualsiasi app compatibile con TOTP.
        </p>
      </>),
      pl_PL: (<>
        <p>
        W tym kroku najlepiej skonfigurować go na urządzeniu, na które planujesz używać.
        </p>
        <p>
        Odwiedź App Store na telefonie, tablecie lub komputerze. Wyszukaj i pobierz aplikację uwierzytelniacza. Możesz użyć aplikacji Google Authenticator, Microsoft Authenticator, Authy lub dowolnej aplikacji zgodnej z TOTP.
        </p>
      </>),
      th_TH: (<>
        <p>
        สําหรับขั้นตอนนี้ คุณควรตั้งค่าอุปกรณ์ที่คุณวางแผนไว้ในการใช้
        </p>
        <p>
        ไปที่ App Store บนโทรศัพท์ แท็บเล็ต หรือคอมพิวเตอร์ของคุณ ค้นหาและดาวน์โหลดแอปตัวรับรองความถูกต้อง คุณสามารถใช้ตัวรับรองความถูกต้องของ Google, Microsoft Authenticator, Authy หรือแอปที่เข้ากันได้กับ TOTP
        </p>
      </>),
      zh_CN: (<>
        <p>
        對於此步驟,最好將其設置在計劃使用的設備上。
        </p>
        <p>
        訪問手機、平板電腦或計算機上的應用商店。搜索並下載身份驗證器應用。您可以使用 Google 身份驗證器、微軟身份驗證器、Authy 或任何與 TOTP 相容的應用。
        </p>
      </>),
      pt_BR: (<>
        <p>
        Para esta etapa, é melhor configurá-lo no dispositivo que você planeja usar.
        </p>
        <p>
        Visite a App Store em seu telefone, tablet ou computador. Pesquise e baixe um aplicativo autenticador. Você pode usar o Google Authenticator, Microsoft Authenticator, Authy ou qualquer aplicativo compatível com TOTP.
        </p>
      </>),
      ja_JP: (<>
        <p>
        この手順では、使用するデバイスで設定することをお勧めします。
        </p>
        <p>
        スマートフォン、タブレット、またはコンピューターで App Store にアクセスします。認証アプリを検索してダウンロードします。Google 認証システム、マイクロソフト認証システム、認証、または TOTP 互換アプリを使用できます。
        </p>
      </>),
    },
    step2Text0: {
      en_US: <h4>Configure Your Authenticator App</h4>,
      de_DE: <h4>Konfigurieren Ihrer Authenticator App</h4>,
      el_GR: <h4>Ρύθμιση παραμέτρων της εφαρμογής ελέγχου ταυτότητας</h4>,
      es_ES: <h4>Configure su aplicación Authenticator</h4>,
      fr_FR: <h4>Configurer votre application Authenticator</h4>,
      fr_CA: <h4>Configurer votre application Authenticator</h4>,
      it_IT: <h4>Configurare l'app Authenticator</h4>,
      pl_PL: <h4>Konfigurowanie aplikacji Authenticator</h4>,
      th_TH: <h4>กําหนดค่าแอปตัวรับรองความถูกต้องของคุณ</h4>,
      zh_CN: <h4>設定驗證器應用程式</h4>,
      pt_BR: <h4>Configure seu aplicativo autenticador</h4>,
      ja_JP: <h4>認証アプリケーションの構成</h4>,
    },
    step2Text1: {
      en_US: <>Scan the QR Code to the right into the app.</>,
      de_DE: <>Scannen Sie den QR-Code rechts in die App.</>,
      el_GR: <>Σαρώστε τον κωδικό QR προς τα δεξιά στην εφαρμογή.</>,
      es_ES: <>Escanee el código QR a la derecha en la aplicación.</>,
      fr_FR: <>Scannez le QR Code vers la droite dans l'application.</>,
      fr_CA: <>Scannez le QR Code vers la droite dans l'application.</>,
      it_IT: <>Scansione del codice QR verso destra nell'app.</>,
      pl_PL: <>Zeskanuj kod QR po prawej stronie w aplikacji.</>,
      th_TH: <>สแกนรหัส QR ทางด้านขวาลงในแอพ</>,
      zh_CN: <>扫描右侧的QR码进入应用程序。</>,
      pt_BR: <>Digitalize o QR Code para a direita no aplicativo.</>,
      ja_JP: <>アプリの右側にあるQRコードをスキャンします。</>,
    },
    step2Text2: {
      en_US: 'OR',
      de_DE: 'oder',
      el_GR: 'ή',
      es_ES: 'O',
      fr_FR: 'OU',
      fr_CA: 'OU',
      it_IT: 'O',
      pl_PL: 'LUB',
      th_TH: 'หรือ',
      zh_CN: '要么',
      pt_BR: 'OU',
      ja_JP: 'または',
    },
    step2Text3: {
      en_US: 'Manually enter the secret key below in the app.',
      de_DE: 'Geben Sie den geheimen Schlüssel unten in der App manuell ein.',
      el_GR: 'Εισαγάγετε με μη αυτόματο τρόπο το μυστικό κλειδί στην εφαρμογή.',
      es_ES: 'Ingrese manualmente la clave secreta a continuación en la aplicación.',
      fr_FR: "Saisissez manuellement la clé secrète ci-dessous dans l'application.",
      fr_CA: "Saisissez manuellement la clé secrète ci-dessous dans l'application.",
      it_IT: "Immettere manualmente la chiave segreta di seguito nell'app.",
      pl_PL: 'Ręcznie wprowadź tajny klucz poniżej w aplikacji.',
      th_TH: 'ป้อนรหัสลับด้วยตนเองด้านล่างในแอปด้วยตนเอง',
      zh_CN: '在应用程序下方手动输入密钥。',
      pt_BR: 'Insira manualmente a chave secreta abaixo no aplicativo.',
      ja_JP: 'アプリに以下の秘密キーを手動で入力します。',
    },
    step2Key: {
      en_US: 'Key',
      de_DE: 'Schlüssel',
      el_GR: 'Κλειδί',
      es_ES: 'Llave',
      fr_FR: 'Clé',
      fr_CA: 'Clé',
      it_IT: 'Chiave',
      pl_PL: 'Klucz',
      th_TH: 'สำคัญ',
      zh_CN: '键',
      pt_BR: 'Chave',
      ja_JP: 'キー',
    },
    step3Text: {
      en_US: 'Enter the six digit code from the app below.',
      de_DE: 'Geben Sie den sechsstelligen Code aus der folgenden App ein.',
      el_GR: 'Εισαγάγετε τον εξαψήφιο κωδικό από την παρακάτω εφαρμογή.',
      es_ES: 'Ingrese el código de seis dígitos de la aplicación a continuación.',
      fr_FR: "Entrez le code à six chiffres de l'application ci-dessous.",
      fr_CA: "Entrez le code à six chiffres de l'application ci-dessous.",
      it_IT: "Inserisci il codice a sei cifre dall'app in basso.",
      pl_PL: 'Wpisz sześciocyfrowy kod z aplikacji poniżej.',
      th_TH: 'ป้อนรหัสหกหลักจากแอปด้านล่าง',
      zh_CN: '在下面的应用中输入六位数代码。',
      pt_BR: 'Digite o código de seis dígitos no aplicativo abaixo.',
      ja_JP: '以下のアプリから6桁のコードを入力します。',
    },
    step3Verification: {
      en_US: 'Verification Code',
      de_DE: 'Verifizierungs-Schlüssel',
      el_GR: 'Κωδικός επαλήθευσης',
      es_ES: 'Código de Verificación',
      fr_FR: 'Code de vérification',
      fr_CA: 'Code de vérification',
      it_IT: 'Codice di verifica',
      pl_PL: 'Kod weryfikacyjny',
      th_TH: 'รหัสยืนยัน',
      zh_CN: '验证码',
      pt_BR: 'Código de verificação',
      ja_JP: '検証コード',
    },
    step3VerificationError: {
      en_US: 'Verification code must be 6 numbers',
      de_DE: 'Der Bestätigungscode muss aus 6 Zahlen bestehen',
      el_GR: 'Ο κωδικός επαλήθευσης πρέπει να είναι 6 αριθμοί',
      es_ES: 'El código de verificación debe tener 6 números.',
      fr_FR: 'Le code de vérification doit être composé de 6 chiffres',
      fr_CA: 'Le code de vérification doit être composé de 6 chiffres',
      it_IT: 'Il codice di verifica deve essere di 6 numeri',
      pl_PL: 'Kod weryfikacyjny musi składać się z 6 cyfr',
      th_TH: 'รหัสยืนยันต้องเป็นตัวเลข 6 ตัว',
      zh_CN: '验证码必须为6位数字',
      pt_BR: 'O código de verificação deve ter 6 números',
      ja_JP: '確認コードは6桁の数字でなければなりません',
    },
    isRequiredMessage: {
      en_US: 'This field is required',
      de_DE: 'Dieses Feld wird benötigt.',
      el_GR: 'Αυτό το πεδίο απαιτείται.',
      es_ES: 'Este campo es requerido.',
      fr_FR: 'Ce champ est requis.',
      fr_CA: 'Ce champ est requis.',
      it_IT: 'Questo campo è obbligatorio.',
      pl_PL: 'To pole jest wymagane.',
      th_TH: 'ต้องระบุข้อมูลในฟิลด์นี้',
      zh_CN: '这是必填栏。',
      pt_BR: 'Este campo é obrigatório.',
      ja_JP: 'この項目は必須です。',
    }
  };
  return mapping[key][lang];
};